import { render, staticRenderFns } from "./st_container_2_col.vue?vue&type=template&id=65c4509c"
import script from "./st_container_2_col.vue?vue&type=script&lang=ts"
export * from "./st_container_2_col.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports